import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import {
  getGuideStaleSummary,
  listGuideCityOptions,
  listGuides,
  serializeGuidesQuery,
} from "./api";
import type { GuideListFilters, GuideListPage } from "./types";

const LIST_STALE_MS = 30_000;

export const guidesQueryKeys = {
  all: ["guides"] as const,
  list: (filters: GuideListFilters) =>
    [
      "guides",
      "list",
      serializeGuidesQuery({
        cityId: filters.cityId,
        q: filters.q,
        stale: filters.stale,
        status: filters.status,
      }),
    ] as const,
  cities: ["guides", "city-options"] as const,
  staleSummary: ["guides", "stale-summary"] as const,
};

export function useGuidesList(filters: GuideListFilters) {
  return useInfiniteQuery({
    queryKey: guidesQueryKeys.list(filters),
    queryFn: ({ pageParam }): Promise<GuideListPage> =>
      listGuides({ ...filters, cursor: pageParam }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    staleTime: LIST_STALE_MS,
  });
}

export function useGuideCities(enabled = false) {
  return useQuery({
    queryKey: guidesQueryKeys.cities,
    queryFn: listGuideCityOptions,
    enabled,
    staleTime: 5 * 60_000,
  });
}

export function useGuideStaleSummary(enabled = true) {
  return useQuery({
    queryKey: guidesQueryKeys.staleSummary,
    queryFn: getGuideStaleSummary,
    enabled,
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
